import * as R from "ramda";
const getStructureRequestQuery = ({ type, identifiers }) => {
  const { agencyId, code, version = "", subcode } = identifiers;
  return `${type}/${agencyId}/${code}/${version}${R.isNil(subcode) ? "" : `/${subcode}`}`;
};
export {
  getStructureRequestQuery
};
